import { CreateDodatnuUplatuRacunaCommand, DodatneUplateInfoDto, ICreateDodatnuUplatuRacunaCommand, RacuniClient, UpdateDodatnuUplatuRacunaCommand } from './../../../../../../data-api/src/lib/eKompanija-api';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FiskalniRacuniClient, IDodatneUplateInfoDto } from '@kodit/core/data-api';
import { FormHelper } from '@kodit/core/form-definitions';
import { AlertService, Mode } from '@kodit/core/services';
import { DynamicDialogConfig, DynamicDialogRef } from '@kodit/core/shared-ui';
import { FormGroupTypeSafe } from 'angular-typesafe-reactive-forms-helper';
import { OpstaPravilaFiskalnaFormService } from 'libs/core/form-definitions/src/lib/racun/konfiguracija/opsta-pravila-fiskalna-form-service';
import { Subscription } from 'rxjs';
import { RacunInfoService } from '../racun-info/racun-info.service';
import { Validators } from '@angular/forms';

@Component({
  selector: 'kodit-dodatne-uplate-racuna-form',
  templateUrl: './dodatne-uplate-racuna-form.component.html',
  styleUrls: ['./dodatne-uplate-racuna-form.component.scss']
})
export class DodatneUplateRacunaFormComponent implements OnInit, OnDestroy {

  private _subs: Subscription = new Subscription();

  form: FormGroupTypeSafe<ICreateDodatnuUplatuRacunaCommand>;
  mode: Mode;

  constructor(
    public _dialogRef: DynamicDialogRef,
    public _dialogConfig: DynamicDialogConfig,
    private _alertService: AlertService,
    private _client: RacuniClient,
    private _racunInfoService: RacunInfoService,
    private _formHelper: FormHelper
  ) { }

  ngOnInit(): void {
    if (this._dialogConfig.data.id) {
      this._load(this._dialogConfig.data.id);
      this.mode = Mode.EDIT;
    } else {
      this._dialogConfig.data = null;
      this.mode = Mode.NEW;
    }
    this.form = this._racunInfoService.GetDodatnaUplataFormGroup();

    this._subs.add(
      this._dialogRef.onSubmit.subscribe(() => {
        this.save();
      })
    );

    this.form.controls.id.setValue(this._racunInfoService.racunInfoDto$.value.id);
    if(this.mode == Mode.NEW){
      this.form.controls.iznosUplate.setValue(this._racunInfoService.racunInfoDto$.value.dodatneUplateInfoDto.preostaliIznosZaPlacanje);
      this.form.controls.iznosUplate.setValidators([
          Validators.max(this._racunInfoService.racunInfoDto$.value.dodatneUplateInfoDto.preostaliIznosZaPlacanje),
          Validators.min(0.01),
      ]);
    }else{
      this.form.controls.iznosUplate.setValidators([
        Validators.max(this._racunInfoService.racunInfoDto$.value.dodatneUplateInfoDto.preostaliIznosZaPlacanje
            + this._dialogConfig.data.iznosUplate),
        Validators.min(0.01),
      ]);
      this.form.controls.id.patchValue(this._dialogConfig.data.id);
    }

  }

  private save() {
    if (!this.form.valid) {
      this._formHelper.invalidateForm(this.form);
      return;
    }

    if (this.mode === Mode.NEW) {
      this._subs.add(
        this._client
          .createDodatnuUplatuRacuna(
            this.form.value as CreateDodatnuUplatuRacunaCommand)
          .subscribe(
            (res) => {
              this._alertService.addSuccessMsg(res.messages[0]);

              this._dialogRef.close(res.data);
            },
            (error) => {
              this._subs.add(
                error.subscribe((x: string) => {
                  this._alertService.addFailedMsg(x);
                })
              );
            }
          )
      );
    }else {
      this._subs.add(
        this._client
          .updateDodatnuUplatuRacuna(this.form.value as UpdateDodatnuUplatuRacunaCommand)
          .subscribe(
            (res) => {
              this._alertService.addSuccessMsg(res.messages[0]);

              this._dialogRef.close(res.data);
            },
            (error) => {
              this._subs.add(
                error.subscribe((x: string) => {
                  this._alertService.addFailedMsg(x);
                })
              );
            }
          )
      );
    }
  }

  private _load(id: number) {
    this._subs.add(
      this._client.getDodatnaUplataById(id).subscribe((res) => {
        this.form.patchValue({
          iznosUplate: res.data?.uplacenIznos,
          tipTransakcije: res.data?.tipTransakcije
        });
      })
    );
  }

  ngOnDestroy(): void {
    this._subs.unsubscribe();
  }

}
